import PropTypes from "prop-types";
import { Tabs } from "@/config/antd";

const EventTabs = ({ activeTab, onTabChange, items }) => {
  return (
    <Tabs
      activeKey={activeTab}
      onChange={onTabChange}
      items={items}
      className="custom-tabs"
      tabBarStyle={{
        marginBottom: "24px",
      }}
    />
  );
};

EventTabs.propTypes = {
  activeTab: PropTypes.oneOf(["schedules", "speakers"]),
  onTabChange: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string,
      children: PropTypes.node,
    })
  ),
};

export default EventTabs;
